import { TenantPreference } from '../entity'

export const BaseTenantPreferenceEvent = {
  context: 'TENANT_PREFERENCE',
  data: null as unknown as TenantPreference,
} as const
